import { defineMessages } from 'react-intl';

export const MESSAGES = defineMessages({
    similarityScore: {
        defaultMessage: 'Similarity score',
        id: 'iaso.label.similarity_score',
    },
    title: {
        defaultMessage: 'Links validation',
        id: 'iaso.links.title',
    },
    refresh: {
        defaultMessage: 'Refresh',
        id: 'iaso.label.refresh',
    },
    runsTitle: {
        defaultMessage: 'Algorithms runs',
        id: 'iaso.label.algorithmsRuns',
    },
    name: {
        defaultMessage: 'Name',
        id: 'iaso.label.name',
    },
    origin: {
        defaultMessage: 'Origin',
        id: 'iaso.label.origin',
    },
    source: {
        defaultMessage: 'Source',
        id: 'iaso.label.source',
    },
    version: {
        defaultMessage: 'Version',
        id: 'iaso.label.version',
    },
    destination: {
        defaultMessage: 'Destination',
        id: 'iaso.label.destination',
    },
    updatedAt: {
        defaultMessage: 'Updated',
        id: 'iaso.label.updated_at',
    },
    algorithm: {
        defaultMessage: 'Algorithm',
        id: 'iaso.label.algorithm',
    },
    validator: {
        defaultMessage: 'Validator',
        id: 'iaso.label.validator',
    },
    validated: {
        defaultMessage: 'Valid',
        id: 'iaso.forms.valid',
    },
    notValidated: {
        defaultMessage: 'Not validated',
        id: 'iaso.forms.notValidated',
    },
    details: {
        defaultMessage: 'Details',
        id: 'iaso.label.details',
    },
    endedAt: {
        defaultMessage: 'Stopped at',
        id: 'iaso.label.ended_at',
    },
    links: {
        defaultMessage: 'Links',
        id: 'iaso.label.links',
    },
    sourceorigin: {
        id: 'iaso.label.sourceorigin',
        defaultMessage: 'Origin source',
    },
    sourceoriginversion: {
        id: 'iaso.label.sourceoriginversion',
        defaultMessage: 'Origin source version',
    },
    sourcedestination: {
        id: 'iaso.label.sourcedestination',
        defaultMessage: 'Destination source',
    },
    sourcedestinationversion: {
        id: 'iaso.label.sourcedestinationversion',
        defaultMessage: 'Destination source version',
    },
    cancel: {
        id: 'iaso.label.cancel',
        defaultMessage: 'Cancel',
    },
    execute: {
        id: 'iaso.label.execute',
        defaultMessage: 'Execute',
    },
    noDifference: {
        id: 'iaso.label.noDifference',
        defaultMessage: 'No difference',
    },
    loading: {
        defaultMessage: 'Loading',
        id: 'iaso.label.loading',
    },
    search: {
        defaultMessage: 'Search',
        id: 'iaso.search',
    },
    status: {
        id: 'iaso.forms.status',
        defaultMessage: 'Status',
    },
    rejected: {
        id: 'iaso.forms.rejectedCap',
        defaultMessage: 'Rejected',
    },
    new: {
        id: 'iaso.forms.newCap',
        defaultMessage: 'New',
    },
    orgUnitTypes: {
        id: 'iaso.datasources.label.orgUnitTypes',
        defaultMessage: 'Org Unit Types',
    },
    validationStatus: {
        id: 'iaso.forms.validationStatus',
        defaultMessage: 'Validation status',
    },
    from: {
        id: 'iaso.label.from',
        defaultMessage: 'From',
    },
    to: {
        id: 'iaso.label.to',
        defaultMessage: 'to',
    },
});

export default MESSAGES;
